import {connect} from 'react-redux';
import {get} from 'lodash/fp';
import {createStructuredSelector} from 'reselect';

import ProfileEditNotesPage from '/component/partial/profile/ProfileEditNotesPage';
import {COACH_NOTES_STATE_IS_LOADING} from '/enum/coach.enum';
import {USER_TYPES} from '/enum/tealium.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {setCoachNotesState, updateCoachNotes} from '/redux/action/coach.action';
import {notesById, notesUpdatedTsById} from '/redux/selector/coach.selector';
import {paidAsRankDescLastMonth} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {withHOC} from '/util/hoc.util';
import {fromProps, withProps} from '/util/selector.util';

const withCoachId = withProps({
  coachId: fromProps(get('recordId')),
});
export default withHOC(
  connect(
    createStructuredSelector({
      notes: withCoachId(notesById),
      notesUpdatedTs: withCoachId(notesUpdatedTsById),
      lastPaidRank: withProps({coachId: userId})(paidAsRankDescLastMonth),
    }),
    dispatch => ({
      updateCoachNotes: ({coachId, body}: any) =>
        // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
        dispatch(updateCoachNotes({coachId, body})),
      setCoachNotesState: ({coachId, stateName, stateValue}: any) =>
        dispatch(
          // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
          setCoachNotesState({
            coachId,
            stateName,
            stateValue,
          }),
        ),
    }),
    (stateProps, dispatchProps, ownProps) => {
      const {recordId: coachId} = ownProps;
      return {
        ...stateProps,
        ...dispatchProps,
        ...ownProps,
        userType: USER_TYPES.coach,
        updateNotes: ({body}: any) => {
          return dispatchProps.updateCoachNotes({coachId, body});
        },
        setState: () => {
          return dispatchProps.setCoachNotesState({
            coachId,
            stateName: COACH_NOTES_STATE_IS_LOADING,
            stateValue: true,
          });
        },
      };
    },
  ),
  withTranslation('screen.coachProfile.section.editNotes'),
)(ProfileEditNotesPage);
